import { accessRole } from "../../../../../helpers/access_role"
import { config } from "../../../../../helpers/config_global"
import React, { Component, Fragment } from "react"
import { Redirect } from "react-router-dom"

import { Tooltip } from "reactstrap"

import MKIDatatable from "../../../../../modules/mki-datatable/lib"

import { cancelToken } from "../../../../../services/adapters/base"

import DataTableBloc from "../Blocs/DataTableBloc"
import apiResponse from "../../../../../services/apiResponse"
import { ConfirmAlert } from "../../../../../helpers/ui/alert"

import ReactTimeAgo from "react-time-ago"

class TableInactiveComponent extends Component {
    dataTableBloc = new DataTableBloc()

    source
    historyTable = "historySettingCronInactive"
    defaultOrder = "job_name"
    defaultSize = 10
    defaultSort = "asc"
    configDatatable = {
        ...config("datatable"),
        sort: {
            column: this.defaultOrder,
            order: this.defaultSort,
        },
    }

    constructor(props) {
        super(props)
        this.state = {
            showHistory: false,
            accessId: null,
            tooltip: false,
            defaultSize: 10,
            rows: [],
            totalRow: 0,
            loadingTable: true,
            filter: sessionStorage.getItem(this.historyTable)
                ? JSON.parse(sessionStorage.getItem(this.historyTable))
                : {
                      filter_value: "",
                      page_number: 1,
                      page_size: this.defaultSize,
                      sort_order: {
                          column: this.defaultOrder,
                          order: this.defaultSort,
                      },
                  },
        }
    }
    toggleTooltip = () => this.setState({ tooltip: !this.state.tooltip })

    loadData = async () => {
        /* history Datatable */
        sessionStorage.setItem(
            this.historyTable,
            JSON.stringify(this.state.filter)
        )

        /* kirim ke server */
        let offset =
            (this.state.filter.page_number - 1) * this.state.filter.page_size
        if (this.state.defaultSize !== this.state.filter.page_size) {
            this.setState({
                defaultSize: this.state.filter.page_size,
            })
            offset = 0
            this.configDatatable.page_number = 1
        }
        const query = {
            search: this.state.filter.filter_value,
            limit: this.state.filter.page_size,
            offset: offset,
            order: this.state.filter.sort_order.column,
            sort: this.state.filter.sort_order.order,
            status: 0,
        }
        await this.dataTableBloc.fetchRowTable(query, this.source.token)
    }

    setTokenAPI = () => {
        if (typeof this.source != typeof undefined) {
            this.source.cancel()
        }
        this.source = cancelToken()
        this.loadData()
    }

    componentDidMount() {
        this.setTokenAPI()

        this.dataTableBloc.rowtableChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.INITIAL:
                    this.setState({
                        loadingTable: false,
                    })
                    break
                case apiResponse.LOADING:
                    this.setState({
                        loadingTable: true,
                    })
                    break
                case apiResponse.COMPLETED:
                    const response = result.data.response
                    this.setState({
                        totalRow: response.total,
                        rows: response.result,
                        loadingTable: false,
                    })
                    break
                case apiResponse.ERROR:
                    break
                default:
                    break
            }
        })

        this.dataTableBloc.activeChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    this.setState(
                        {
                            loading: false,
                            success: true,
                            loadingTable: true,
                        },
                        function () {
                            this.setTokenAPI()
                            this.props.handleActiveSuccess()
                        }
                    )
                    break
                case apiResponse.ERROR:
                    this.setState({
                        loading: false,
                        failed: true,
                    })
                    break
                default:
                    break
            }
        })
    }

    confirmResponse = (response) => {
        let forState = {}
        switch (response) {
            case "cancel":
                forState = {
                    confirm: false,
                }
                break
            case "confirm":
                forState = {
                    loading: true,
                    confirm: false,
                }
                this.inactiveData()
                break
            case "success":
                forState = {
                    success: false,
                }
                break
            case "failed":
                forState = {
                    failed: false,
                }
                break
            default:
        }
        this.setState(forState)
    }

    inactiveData = async () => {
        await this.dataTableBloc.fetchActive({ uuid: this.state.jobUuid })
    }

    componentWillUnmount() {
        this.dataTableBloc.rowtableChannel.unsubscribe()
        this.dataTableBloc.activeChannel.unsubscribe()
    }

    columns = [
        {
            key: "job_schedule",
            text: "Ekspresi",
            align: "center",
            sortable: true,
            width: "180",
        },
        {
            key: "job_name",
            text: "Nama Jadwal",
            sortable: true,
        },
        {
            key: "job_query",
            text: "Query",
            sortable: true,
        },
        {
            key: "action",
            text: "Action",
            width: 120,
            sortable: false,
            align: "center",
            cell: (record) => {
                const thisId = record.access_uuid
                return (
                    <Fragment>
                        {accessRole("update") ? (
                            <span>
                                <button
                                    className="btn btn-danger btn-sm"
                                    id={"active-" + thisId}
                                    onClick={() => {
                                        this.setState({
                                            jobUuid: record.job_uuid,
                                            confirm: true,
                                        })
                                    }}
                                    style={{
                                        padding: "2px 5px",
                                    }}
                                >
                                    <i className="uil-history-alt"></i>
                                </button>
                                <Tooltip
                                    style={{
                                        marginBottom: 2,
                                    }}
                                    placement="top"
                                    isOpen={this.state["active" + thisId]}
                                    target={"active-" + thisId}
                                    toggle={() => {
                                        this.setState({
                                            ["active" + thisId]:
                                                !this.state["active" + thisId],
                                        })
                                    }}
                                >
                                    Aktifkan
                                </Tooltip>
                            </span>
                        ) : (
                            <button
                                className="btn btn-soft-secondary btn-sm"
                                disabled={true}
                                style={{
                                    padding: "2px 5px",
                                }}
                            >
                                <i className="uil-history-alt"></i>
                            </button>
                        )}
                    </Fragment>
                )
            },
        },
    ]
    render() {
        return (
            <>
                <MKIDatatable
                    className={this.configDatatable.tableClass}
                    config={this.configDatatable}
                    records={this.state.rows}
                    columns={this.columns}
                    dynamic={true}
                    total_record={this.state.totalRow}
                    initial={this.state.filter}
                    onChange={(filter) => {
                        this.setState(
                            {
                                loadingTable: true,
                                filter: filter,
                            },
                            function () {
                                this.setTokenAPI()
                            }
                        )
                    }}
                    loading={this.state.loadingTable}
                />

                <ConfirmAlert
                    confirmTitle="Konfirmasi!"
                    confirmInfo="Apakah anda yakin akan mengaktifkan data ini?"
                    loadingTitle="Mengirim data..."
                    loadingInfo="Tunggu beberapa saat"
                    successTitle="Berhasil!"
                    successInfo="Data berhasil diaktifkan"
                    failedTitle="Gagal!"
                    failedInfo="Data gagal diaktifkan"
                    showConfirm={this.state.confirm}
                    showLoading={this.state.loading}
                    showSuccess={this.state.success}
                    showFailed={this.state.failed}
                    response={this.confirmResponse}
                />
            </>
        )
    }
}

export default TableInactiveComponent
